[
  {
    "name": "b766ca09-09fa-41d1-8ee5-e27751a64cc4",
    "date": "2025-07-24 06:51",
    "result": "PENDING",
    "dataset": "BOSNIA Dataset.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "9300c44b-2b9b-4c97-9f8d-75f69dfb5c4b",
    "date": "2025-07-24 06:42",
    "result": "VALID",
    "dataset": "AIP-RUN-subset-small-AIXM511.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "9300c44b-2b9b-4c97-9f8d-75f69dfb5c4b.pdf"
  },
  {
    "name": "bd02df90-416d-4909-887f-3470b539ea10",
    "date": "2025-07-24 06:36",
    "result": "VALID",
    "dataset": "AIP-RUN-subset-small-AIXM511.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "bd02df90-416d-4909-887f-3470b539ea10.pdf"
  },
  {
    "name": "8cde43f9-f668-43bb-9320-74d2aa272d7b",
    "date": "2025-07-22 07:13",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": "8cde43f9-f668-43bb-9320-74d2aa272d7b.pdf"
  },
  {
    "name": "4d88ce85-db23-4a2e-85c7-39d7827c326a",
    "date": "2025-07-16 06:02",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-FABEC-BR.sch, AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "4d88ce85-db23-4a2e-85c7-39d7827c326a.pdf"
  },
  {
    "name": "1fb16a6b-c5b0-4ddb-844f-2144565d4c5f",
    "date": "2025-07-14 07:43",
    "result": "INVALID",
    "dataset": "aip-dataset-BASELINE-2024-05-12T14_00_00Z3744718723436516027.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "d42d6904-5871-4113-8312-c09098947bf5",
    "date": "2025-07-14 07:31",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch, AIXM-5.1-FABEC-BR.sch",
    "certificate": ""
  },
  {
    "name": "795dfc78-6b7c-4f68-b086-977d9c7394f7",
    "date": "2025-07-14 07:30",
    "result": "VALID",
    "dataset": "DesignatedPoints (3).xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "795dfc78-6b7c-4f68-b086-977d9c7394f7.pdf"
  },
  {
    "name": "48b03e5e-676e-4a17-9aaf-a0224f4babb5",
    "date": "2025-07-14 07:28",
    "result": "INVALID",
    "dataset": "aixm-update-UN-ab5fd44a-d2fc-46d5-94d7-5960b45caf80 (2).xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "4670f16c-a0c5-4e8f-acb3-6198d7f88f49",
    "date": "2025-07-10 08:35",
    "result": "VALID",
    "dataset": "BOSNIA Dataset.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "4670f16c-a0c5-4e8f-acb3-6198d7f88f49.pdf"
  },
  {
    "name": "f0aa4b55-3be7-453e-b6e8-8f5eb144c2c4",
    "date": "2025-07-09 09:09",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "f0aa4b55-3be7-453e-b6e8-8f5eb144c2c4.pdf"
  },
  {
    "name": "033cf514-0e1a-41bb-acf0-02b92cdc482b",
    "date": "2025-07-09 09:08",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "294c54ae-267c-45f5-8365-fa8137f568fa",
    "date": "2025-07-09 09:08",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "d88ec95b-dc88-4059-94fb-c935809cb0f9",
    "date": "2025-07-09 09:07",
    "result": "FAILED",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "6b4b8920-9672-4875-8cea-a79fab4f5645",
    "date": "2025-07-09 09:02",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-EAD-BR.sch, AIXM-5.2-coding-guidelines-BR.sch, AIXM-5.2-FABEC-BR.sch",
    "certificate": "6b4b8920-9672-4875-8cea-a79fab4f5645.pdf"
  },
  {
    "name": "e30d1088-257b-4f80-b31d-7e35b52a191c",
    "date": "2025-07-09 09:01",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "20595f80-8acb-499d-bd65-e5c3dc69ad34",
    "date": "2025-07-09 09:00",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "20595f80-8acb-499d-bd65-e5c3dc69ad34.pdf"
  },
  {
    "name": "694e1290-74ff-4377-8341-9f871a8b7e32",
    "date": "2025-07-09 08:59",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "164dce5f-d4ea-4ef6-9eb6-6e2c73163e76",
    "date": "2025-07-09 08:58",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": "164dce5f-d4ea-4ef6-9eb6-6e2c73163e76.pdf"
  },
  {
    "name": "44313405-491c-4871-bd05-9e8cbdbff166",
    "date": "2025-07-09 08:58",
    "result": "FAILED",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-FABEC-BR.sch",
    "certificate": ""
  },
  {
    "name": "fbbd09f3-d159-481a-9eba-88f16eec63f7",
    "date": "2025-07-09 08:55",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-FABEC-BR.sch, AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "fbbd09f3-d159-481a-9eba-88f16eec63f7.pdf"
  },
  {
    "name": "9a293c6b-5a56-4361-a4c4-07fcc7705a1f",
    "date": "2025-07-09 08:54",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "04bd5787-5f7a-44e9-99ed-3b28f5969798",
    "date": "2025-07-09 08:31",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "43430d2f-0189-4981-b70f-6d383830d1ab",
    "date": "2025-07-09 08:22",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-FABEC-BR.sch, AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "43430d2f-0189-4981-b70f-6d383830d1ab.pdf"
  },
  {
    "name": "63b06d14-f8e1-46cb-9721-643fc78ccc1a",
    "date": "2025-07-09 03:27",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "63b06d14-f8e1-46cb-9721-643fc78ccc1a.pdf"
  },
  {
    "name": "7808346f-8457-4018-a700-19225f6afc4c",
    "date": "2025-07-09 03:27",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": "7808346f-8457-4018-a700-19225f6afc4c.pdf"
  },
  {
    "name": "1ee9141e-6003-44e6-ab61-6e38720da871",
    "date": "2025-07-08 07:24",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": "1ee9141e-6003-44e6-ab61-6e38720da871.pdf"
  },
  {
    "name": "03be08c2-46d3-4d33-9e21-382271bd5052",
    "date": "2025-07-08 06:30",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "AIXM-5.1-coding-guidelines-BR.sch, AIXM-5.1-FABEC-BR.sch",
    "certificate": ""
  },
  {
    "name": "1b9c2eca-36f4-4aea-a2cf-22efe6524151",
    "date": "2025-07-08 05:18",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": "1b9c2eca-36f4-4aea-a2cf-22efe6524151.pdf"
  },
  {
    "name": "e2228d98-1088-4f8e-be86-d5bdd23a84a4",
    "date": "2025-07-07 14:09",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "8046caae-4499-4a81-803c-e6a000c8ec97",
    "date": "2025-07-07 14:08",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-EAD-BR.sch, AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "fbccd28c-9857-4fa8-b1eb-3d2925a9e2b1",
    "date": "2025-07-07 14:08",
    "result": "INVALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "84f263bd-2ce0-4f63-966f-f74c6944751b",
    "date": "2025-07-07 14:06",
    "result": "INVALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-FABEC-BR.sch, AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "0f6c6825-1ba8-4c9b-b28d-810bcbef4f62",
    "date": "2025-07-07 09:06",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch, AIXM-5.2-FABEC-BR.sch",
    "certificate": ""
  },
  {
    "name": "e80f3356-28e1-44ef-98e2-3b873e92a960",
    "date": "2025-06-17 08:29",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-AIP-tables-BR.sch",
    "certificate": "e80f3356-28e1-44ef-98e2-3b873e92a960.pdf"
  },
  {
    "name": "32502a90-15ac-4c81-820b-2646f2115a72",
    "date": "2025-05-15 10:27",
    "result": "FAILED",
    "dataset": "BD_2022-12-01_urba.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "",
    "certificate": ""
  },
  {
    "name": "e681d493-eb1e-4660-a0b7-3e7b3a9b4463",
    "date": "2025-05-15 10:15",
    "result": "FAILED",
    "dataset": "BD_2022-12-01_urba.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "",
    "certificate": ""
  },
  {
    "name": "b379a686-086e-4e04-b5c2-79fdd5f1ec96",
    "date": "2025-05-15 10:09",
    "result": "FAILED",
    "dataset": "BD_2022-12-01_urba.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "",
    "certificate": ""
  },
  {
    "name": "59615697-65dc-42f1-89b3-5696e9dcbb55",
    "date": "2025-05-15 10:04",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "59615697-65dc-42f1-89b3-5696e9dcbb55.pdf"
  },
  {
    "name": "53e8e6a5-de0a-4dec-951b-69eda76b8ff7",
    "date": "2025-05-15 10:03",
    "result": "INVALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "481ed6ab-543c-4f14-af0e-ce06fb8ae882",
    "date": "2025-05-14 05:07",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "481ed6ab-543c-4f14-af0e-ce06fb8ae882.pdf"
  },
  {
    "name": "a1a8c5f6-06ea-4c3f-8281-66194a08cec8",
    "date": "2025-05-14 05:07",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "a970d73b-ef4f-4795-aa26-11f2f1521ed8",
    "date": "2025-05-14 05:06",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "a970d73b-ef4f-4795-aa26-11f2f1521ed8.pdf"
  },
  {
    "name": "13750caa-eb22-4d67-b96c-f08a54efdaf4",
    "date": "2025-05-14 05:06",
    "result": "INVALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "4908059a-85a7-48ea-8dda-639931d1d193",
    "date": "2025-05-14 05:06",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "4908059a-85a7-48ea-8dda-639931d1d193.pdf"
  },
  {
    "name": "5e3694a8-a81c-49a2-8f8a-378f0d4cb081",
    "date": "2025-05-14 05:05",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "5e3694a8-a81c-49a2-8f8a-378f0d4cb081.pdf"
  },
  {
    "name": "4f8fb16b-01f8-4c38-af62-48e111fcb5dd",
    "date": "2025-05-14 04:37",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "4f8fb16b-01f8-4c38-af62-48e111fcb5dd.pdf"
  },
  {
    "name": "f35e13c5-30fd-425d-aa3e-c65505011f13",
    "date": "2025-05-14 04:36",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "f35e13c5-30fd-425d-aa3e-c65505011f13.pdf"
  },
  {
    "name": "072f1545-22cc-4a17-b14c-4113802f4250",
    "date": "2025-05-12 07:52",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "072f1545-22cc-4a17-b14c-4113802f4250.pdf"
  },
  {
    "name": "9901e364-1242-482a-9cee-7b8237bd524f",
    "date": "2025-05-12 07:51",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "9901e364-1242-482a-9cee-7b8237bd524f.pdf"
  },
  {
    "name": "d7b924b4-7d38-4a08-943c-3e263cff1d88",
    "date": "2025-05-12 07:32",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "d7b924b4-7d38-4a08-943c-3e263cff1d88.pdf"
  },
  {
    "name": "51f1a47c-116b-4549-93e7-244844986029",
    "date": "2025-05-12 07:32",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "51f1a47c-116b-4549-93e7-244844986029.pdf"
  },
  {
    "name": "4c6922b0-4b57-42bf-bc56-8a0627735aa8",
    "date": "2025-05-12 07:25",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "4c6922b0-4b57-42bf-bc56-8a0627735aa8.pdf"
  },
  {
    "name": "7d3849bb-04f4-4eaa-8ad4-4e8b928b54b2",
    "date": "2025-05-12 07:23",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "7d3849bb-04f4-4eaa-8ad4-4e8b928b54b2.pdf"
  },
  {
    "name": "113e20ee-e820-4aa8-ad0e-d89596c46ff9",
    "date": "2025-05-12 07:23",
    "result": "INVALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1-AIP-dataset",
    "bizrule": "",
    "certificate": ""
  },
  {
    "name": "0836349e-274f-4e8c-bd86-d4b1332f1fa1",
    "date": "2025-05-12 07:21",
    "result": "INVALID",
    "dataset": "AIP-DS-invalid.xml",
    "version": "AIXM-5.1",
    "schema": "AIXM-5.1 original schema",
    "bizrule": "",
    "certificate": ""
  },
  {
    "name": "20bcbe7d-b64e-4c5d-b0f7-8ed530421685",
    "date": "2025-05-12 07:17",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "20bcbe7d-b64e-4c5d-b0f7-8ed530421685.pdf"
  },
  {
    "name": "b7145342-a218-4c4d-b814-a005aa6b9ce1",
    "date": "2025-05-12 07:15",
    "result": "VALID",
    "dataset": "bosnia-ahp-2.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "",
    "certificate": "b7145342-a218-4c4d-b814-a005aa6b9ce1.pdf"
  },
  {
    "name": "57ca36bf-5c7a-45ef-a69f-008421e35aad",
    "date": "2025-05-01 10:09",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "57ca36bf-5c7a-45ef-a69f-008421e35aad.pdf"
  },
  {
    "name": "3a1435f5-c2c9-437d-9c2e-d232fafd7039",
    "date": "2025-05-01 10:08",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "3a1435f5-c2c9-437d-9c2e-d232fafd7039.pdf"
  },
  {
    "name": "756a3791-dff1-410d-abae-c983ceca5021",
    "date": "2025-05-01 10:07",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "756a3791-dff1-410d-abae-c983ceca5021.pdf"
  },
  {
    "name": "ceb59541-edf1-4ff1-a7f2-7ca1ccc55ab3",
    "date": "2025-05-01 10:03",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "ceb59541-edf1-4ff1-a7f2-7ca1ccc55ab3.pdf"
  },
  {
    "name": "e3f14350-79f7-429f-92e0-929d3316de84",
    "date": "2025-05-01 10:03",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "1a196bc3-4439-423e-bf34-0951618de653",
    "date": "2025-05-01 10:02",
    "result": "VALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "",
    "certificate": "1a196bc3-4439-423e-bf34-0951618de653.pdf"
  },
  {
    "name": "8e32a2ed-8c61-4918-a897-3389c685ed88",
    "date": "2025-04-30 10:38",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-EAD-BR.sch, AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "8c0b27f7-6e09-45e8-94a5-842b1466a9dd",
    "date": "2025-04-30 10:38",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-EAD-BR.sch",
    "certificate": ""
  },
  {
    "name": "f9e956fa-cdef-4fb7-a071-d470793f4eb7",
    "date": "2025-04-30 10:37",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-AIP-tables-BR.sch",
    "certificate": ""
  },
  {
    "name": "fb06efd0-c48b-4640-bdf6-97c367a76bb6",
    "date": "2025-04-29 09:51",
    "result": "INVALID",
    "dataset": "AIP-DS-52-valid.xml",
    "version": "AIXM-5.2",
    "schema": "AIXM-5.2 original schema",
    "bizrule": "AIXM-5.2-coding-guidelines-BR.sch",
    "certificate": ""
  },
  {
    "name": "7f9753c3-aa08-4216-b4fc-ef2de0556b52",
    "date": "2025-03-26 04:55",
    "result": "INVALID",
    "dataset": "aixm_5_1_1_icao_common_data_subset_draft.xml",
    "version": "AIXM-5.1.1",
    "schema": "AIXM-5.1.1 original schema",
    "bizrule": "AIXM-5.1.1-coding-guidelines-BR.sch",
    "certificate": ""
  }
]